import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';
import Deflector from './Deflector';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function ShotBlockedEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const { result } = event;
  const period = periods[event.period].name;
  const shooter = players[event.player];
  const deflector = event.deflect && players[event.deflect.player];

  const blocker = players[result.player];
  const team = teams[blocker.team].id;

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type={`${deflector ? 'Deflected ' : ''}Shot Blocked`}
    >
      <Typography variant="body2">
        Shot by{' '}
        <span className={classes.bold}>{shooter.name}</span>
        <Deflector deflector={deflector} />
        {' '}is blocked by{' '}
        <span className={classes.bold}>{blocker.name}</span>
      </Typography>
    </Base>
  )
}

export default ShotBlockedEvent;
